// React
import React from 'react'
import { connect as reduxConnect } from 'react-redux'
import PropTypes from 'prop-types'

// Libraries
import _range from 'lodash/range'

class Pagination extends React.Component {
  static displayName = 'Pagination'

  static propTypes = {
    page: PropTypes.any,
    pages: PropTypes.any,
    padding: PropTypes.number,
    showPrev: PropTypes.bool,
    showNext: PropTypes.bool,
    handlePage: PropTypes.func,
    handleNextPage: PropTypes.func,
    handlePrevPage: PropTypes.func
  }

  renderPages = () => {
    const allPages = _range(1, (this.props.pages + 1))

    const padding = this.props.padding || 2
    const show = padding * 2 + 1
    let till = Math.min(this.props.pages, this.props.page + padding)
    const from = Math.max(0, till - show)

    till = from + show

    return allPages.slice(from, till).map((page) => {
      const classNames = []

      if (page === this.props.page) {
        classNames.push('bq-pagination-current bq-branded')
      }

      return (
        <span key={`page-${page}`} className={`bq-pagination-page ${classNames.join(' ')}`}>
          {(page !== this.props.page) && <button onClick={this.props.handlePage.bind(null, page)}>{page}</button>}
          {(page === this.props.page) && page}
        </span>
      )
    })
  }

  render () {
    if (this.props.pages <= 1) {
      return null
    }

    return (
      <div className="booqable-pagination">
        <div className="bq-pagination-inner">
          {this.props.showPrev && (
            <span className="bq-pagination-page bq-pagination-prev">
              <button onClick={this.props.handlePrevPage}>
                <i className="bq-icon-arrow-left2 fas fa-angle-left" />
              </button>
            </span>
          )}
          {this.renderPages()}
          {this.props.showNext && (
            <span className="bq-pagination-page bq-pagination-next">
              <button onClick={this.props.handleNextPage}>
                <i className="bq-icon-arrow-right2 fas fa-angle-right" />
              </button>
            </span>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const pages = Math.ceil(props.total / props.per)

  return {
    pages,
    showPrev: props.page !== 1,
    showNext: props.page !== pages
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const handlePageChange = (page) => {
    const pages = Math.ceil(props.total / props.per)

    if (page >= 1 && page <= pages) {
      return props.onChange(page)
    }
  }

  return {
    handlePage (page) {
      return handlePageChange(page)
    },
    handlePrevPage () {
      return handlePageChange(props.page - 1)
    },
    handleNextPage () {
      return handlePageChange(props.page + 1)
    }
  }
}

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Pagination)
